(function(){
function init(root){
  if(root.getAttribute('data-ready'))return;
  root.setAttribute('data-ready','1');
  var glass=root.querySelector('.voro-scr__glass');
  var pwr=root.querySelector('.voro-scr__pwr');
  var pwrText=pwr.querySelector('span');
  var hint=root.querySelector('.voro-scr__hint');
  var views=[].slice.call(root.querySelectorAll('[data-view]'));
  var dots=[].slice.call(root.querySelectorAll('.voro-scr__dots i'));
  var dotsBox=root.querySelector('.voro-scr__dots');
  var track=root.querySelector('.voro-scr__track');
  var knob=root.querySelector('.voro-scr__knob');
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var HINT={
    off:'Tap the screen or press Power on to switch it on.',
    boot:'Starting up.',
    pin:'Enter any 4 digits to unlock.',
    dash:'Tap the gear for settings, or the lock to lock it.',
    set:'Pick a setting on the left. Switch to km/h and the dashboard follows.',
    lock:'Drag the yellow knob all the way right to lock and switch off.'
  };
  var intro=root.getAttribute('data-intro')==='1';
  var state='off',timer=0,pin='',kx=0,drag=null;

  function show(n){
    clearTimeout(timer);
    var hadFocus=glass.contains(document.activeElement);
    state=n;
    glass.setAttribute('data-state',n);
    var target=null;
    views.forEach(function(v){
      var on=v.getAttribute('data-view')===n;
      v.classList.toggle('is-on',on);
      if(on){v.removeAttribute('inert');v.removeAttribute('aria-hidden');target=v;}
      else{v.setAttribute('inert','');v.setAttribute('aria-hidden','true');}
    });
    hint.textContent=HINT[n];
    var live=n!=='off';
    pwr.setAttribute('aria-pressed',live?'true':'false');
    pwrText.textContent=live?'Power off':'Power on';
    if(n==='boot')timer=intro?setTimeout(function(){show('dash');},reduce?1600:4200):setTimeout(function(){show('pin');},reduce?700:2500);
    if(n==='pin'){pin='';paintPin();dotsBox.classList.remove('is-ok');}
    if(n==='lock')setKnob(0,false);
    if(hadFocus&&target){
      var f=target.querySelector('button,input')||target;
      try{f.focus({preventScroll:true});}catch(e){f.focus();}
    }
  }

  function paintPin(){dots.forEach(function(d,i){d.classList.toggle('is-in',i<pin.length);});}
  function press(k){
    if(state!=='pin'||pin.length>=4)return;
    pin+=k;paintPin();
    if(pin.length===4){
      dotsBox.classList.add('is-ok');
      timer=setTimeout(function(){show('dash');},reduce?150:480);
    }
  }

  root.addEventListener('click',function(e){
    var go=e.target.closest('[data-go]');
    if(go&&root.contains(go)){show(go.getAttribute('data-go'));return;}
    var key=e.target.closest('[data-key]');
    if(key){press(key.getAttribute('data-key'));return;}
    var pb=e.target.closest('[data-pane-btn]');
    if(pb){
      var id=pb.getAttribute('data-pane-btn');
      root.querySelectorAll('[data-pane-btn]').forEach(function(b){var on=b===pb;b.classList.toggle('is-on',on);if(on)b.setAttribute('aria-current','true');else b.removeAttribute('aria-current');});
      root.querySelectorAll('[data-pane]').forEach(function(p){p.hidden=p.getAttribute('data-pane')!==id;});
      return;
    }
    var sw=e.target.closest('.voro-scr__sw');
    if(sw){sw.setAttribute('aria-checked',sw.getAttribute('aria-checked')==='true'?'false':'true');return;}
    var u=e.target.closest('[data-unit]');
    if(u){setUnit(u.getAttribute('data-unit'));return;}
  });

  glass.addEventListener('keydown',function(e){
    if(state==='pin'&&/^[0-9]$/.test(e.key)){press(e.key);e.preventDefault();}
  });

  pwr.addEventListener('click',function(){show(state==='off'?'boot':'off');});
  glass.querySelector('[data-view="boot"]').addEventListener('click',function(){if(state==='boot')show(intro?'dash':'pin');});

  root.querySelectorAll('.voro-scr__rg input').forEach(function(r){
    var out=r.parentNode.querySelector('output');
    var suf=r.getAttribute('data-suf')||'';
    function paint(){
      var pct=(r.value-r.min)/(r.max-r.min)*100;
      r.style.setProperty('--p',pct+'%');
      out.textContent=r.value+suf;
    }
    r.addEventListener('input',paint);
    paint();
  });

  function setUnit(u){
    var km=u==='km';
    root.querySelectorAll('[data-unit]').forEach(function(b){b.setAttribute('aria-pressed',b.getAttribute('data-unit')===u?'true':'false');});
    root.querySelectorAll('[data-u-spd]').forEach(function(el){el.textContent=km?'km/h':'mph';});
    root.querySelectorAll('[data-u-dist]').forEach(function(el){el.textContent=km?'km':'mi';});
  }

  var d=new Date(),pad=function(x){return (x<10?'0':'')+x;};
  root.querySelectorAll('[data-today]').forEach(function(el){el.textContent=d.getFullYear()+'-'+pad(d.getMonth()+1)+'-'+pad(d.getDate());});

  function maxX(){return track.clientWidth-knob.offsetWidth;}
  function setKnob(x,done){
    kx=x;
    knob.style.transform='translateX('+x+'px)';
    var m=maxX();
    track.style.setProperty('--f',m>0?(x/m).toFixed(3):0);
    knob.classList.toggle('is-done',!!done);
  }
  function finishLock(){
    setKnob(maxX(),true);
    timer=setTimeout(function(){show('off');},reduce?250:750);
  }
  knob.addEventListener('pointerdown',function(e){
    if(state!=='lock'||knob.classList.contains('is-done'))return;
    drag={x0:e.clientX-kx};
    try{knob.setPointerCapture(e.pointerId);}catch(err){}
    knob.classList.add('is-drag');
  });
  knob.addEventListener('pointermove',function(e){
    if(!drag)return;
    setKnob(Math.max(0,Math.min(maxX(),e.clientX-drag.x0)),false);
  });
  function release(){
    if(!drag)return;
    knob.classList.remove('is-drag');
    var done=kx>maxX()*0.8;
    drag=null;
    if(done)finishLock();else setKnob(0,false);
  }
  knob.addEventListener('pointerup',release);
  knob.addEventListener('pointercancel',release);
  knob.addEventListener('click',function(e){if(e.detail===0&&state==='lock')finishLock();});
  knob.addEventListener('keydown',function(e){if(e.key==='ArrowRight'&&state==='lock'){e.preventDefault();finishLock();}});

  show('off');
  // Homepage intro: switch on by itself the first time most of the screen is in view.
  if(intro&&'IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){
      if(!es[0].isIntersecting)return;
      io.disconnect();
      if(state==='off')show('boot');
    },{threshold:.6});
    io.observe(glass);
  }
}
function boot(){[].forEach.call(document.querySelectorAll('.vpdp .voro-scr'),init);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
document.addEventListener('shopify:section:load',boot);
})();
